<template>
  <div>
    <h4>
      <!--router-link class="routerlink" :to="{name:'modeditorindex'}">
        <i class="fa fa-arrow-left"></i>&nbsp;Back
      </router-link>|-->Editing Module <b>{{ mod }}</b>
    </h4>

    <!-- LIST OF MODULES -->
    <div v-if="!chapter">
      <ElRow
        v-if="_.isEmpty(record)"
        :gutter="24"
      >
        <ElCol :span="24">
          <ul>
            <li
              :key="k"
              v-for="(m, k) in modules"
            >
              {{ m.name }}&nbsp;
              <RouterLink :to="{ name: 'modeditormod', params: { mod: m.slug } }">
                <a class="button small">
                  EDIT
                </a>
              </RouterLink>
            </li>
          </ul>
        </ElCol>
      </ElRow>

      <ElRow
        id="start"
        v-else
        :gutter="24"
      >
        <ElCol :span="16">
          <label>Name</label>
          <el-input
            type="text"
            v-model="record.name"
          />
          <label>Slug</label>
          <el-input
            type="text"
            v-model="record.slug"
          />
          <label>Short Intro</label>
          <el-input
            type="textarea"
            rows="4"
            cols="42"
            v-model="record.short_intro"
          />
          <label>Introduction</label>
          <VueEditor
            rows="10"
            v-model="record.introduction"
            :editor-toolbar="customToolbar"
          />
          <label>Status
            <el-input
              type="text"
              v-model="record.status"
            /></label>
        </ElCol>

        <ElCol :span="8">
          <label>Iconic image</label>
          <img :src="record.image" />
          <br clear="all" />
          <br clear="all" />
          <label>Chapters</label>
          <li
            :key="k"
            v-for="(c, k) in record.chapters"
          >
            <RouterLink
              class="editlink"
              :to="{
                name: 'modeditormodchapter',
                params: { mod: record.slug, chapter: c.slug }
              }"
            >
              {{ c.name }}&nbsp;
              <i class="fa fa-edit" />
            </RouterLink>
          </li>
        </ElCol>
        <ElCol :span="24">
          <Center>
            <ElButton
              class="button"
              @click="saveMod"
              type="primary"
            >
              Save Module
            </ElButton>
          </Center>
        </ElCol>
      </ElRow>
    </div>
  </div>
</template>
<script>
import { API } from "../tic"
import { VueEditor } from "vue2-editor"

export default {
  name: "ModEditor",
  props: {
    mod: {
      type: String,
      default: ""
    },
    chapter: {
      type: String,
      default: ""
    }
  },

  components: { VueEditor },

  mounted () {
    if (this.mod) {
      API.get("/get-historical-content/" + this.mod).then(r => {
        this.record = r.data.data
      })
    }

    API.get("/admin/modules-index").then(r => {
      this.modules = r.data
    })
  },

  methods: {
    saveMod () {
      API.post("/admin/module/save", this.record).then(() => {
        this.$notify.success("Module changes saved")
      })
    }
  },

  data () {
    return {
      modules: [],
      record: {},
      icon: {},
      childs: [],
      isLoading: false,
      currentChapter: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote"],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"]
        // ['image', 'code-block']
      ]
    }
  }
}
</script>
<style scoped>
label {
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
  display: inline-block;
}
</style>